import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import {
  InstoreRebate, Disclaimer, ManageCardsButton, InstoreLoginLink,
} from 'core/modules/Instore2/partials';
import { InstoreMotto, useToggleDetailsButton } from '../partials';

import config from '../configs';

function AnonymousView({ offer, isOpenByDefault }) {
  const { disclaimerTitle } = config;
  const { disclaimer, rclonMerchantName } = offer;
  const { ToggleDetailsButton, toggleDetails, isDetailsExpanded } = useToggleDetailsButton(isOpenByDefault);

  return (
    <div
      id="instore"
      className="mn_meInstoreOffer mn_anonymousView"
      data-merchant-name={rclonMerchantName}
    >
      <div className="mn_mainDetails">
        <div className="mn_leftSection">
          <InstoreMotto />
          <InstoreRebate offer={offer} />
        </div>
        <div className="mn_rightSection">
          <InstoreLoginLink className="mn_button">Sign in to get the offer</InstoreLoginLink>
          <ToggleDetailsButton toggleDetails={toggleDetails} isDetailsExpanded={isDetailsExpanded} />
        </div>
      </div>
      {isDetailsExpanded &&
        <div className="mn_moreDetails">
          <div className="mn_buttons"><ManageCardsButton /></div>
          <Disclaimer title={disclaimerTitle}>{disclaimer}</Disclaimer>
        </div>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><AnonymousView {...props} /></ComponentErrorBoundary>;
